"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";

import {
  UserPlus,
  Mail,
  Lock,
} from "lucide-react";

import { useToast } from "@/context/ToastContext";


export default function RegisterPage(){


const router = useRouter();

const toast = useToast();


const [email,setEmail]=useState("");
const [password,setPassword]=useState("");

const [loading,setLoading]=useState(false);



async function register(e:React.FormEvent){

e.preventDefault();

setLoading(true);


try{


const res = await fetch(
"/api/auth/register",
{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
email,
password
})
}
);



const data = await res.json();



if(!res.ok){

toast.error(
data.error || "Ошибка регистрации"
);

return;

}



toast.success(
"Аккаунт создан"
);


router.push("/login");



}catch{


toast.error(
"Ошибка соединения"
);



}finally{


setLoading(false);


}


}




return (

<main className="min-h-screen bg-slate-100 flex items-center justify-center px-5">


<div className="w-full max-w-md">


<div className="bg-slate-900 rounded-3xl p-8 shadow-2xl text-white">


<div className="text-center">


<div className="w-16 h-16 rounded-2xl bg-blue-600 flex items-center justify-center mx-auto">

<UserPlus size={32}/>

</div>


<h1 className="text-3xl font-bold mt-6">
Создать аккаунт
</h1>


<p className="text-slate-300 mt-2">
Начните пользоваться RadeVPN
</p>


</div>



<form
onSubmit={register}
className="mt-8 space-y-5"
>



<div>

<label className="text-sm text-slate-300">
Email
</label>


<input

type="email"

value={email}

onChange={
e=>setEmail(e.target.value)
}

className="w-full mt-2 bg-white text-slate-900 rounded-xl py-3 px-4 outline-none"

required

/>


</div>




<div>

<label className="text-sm text-slate-300">
Пароль
</label>


<input

type="password"

value={password}

onChange={
e=>setPassword(e.target.value)
}

className="w-full mt-2 bg-white text-slate-900 rounded-xl py-3 px-4 outline-none"

minLength={8}

required

/>


</div>




<button

disabled={loading}

className="w-full bg-blue-600 hover:bg-blue-700 transition rounded-xl py-3 font-semibold"

>


{
loading
?
"Создание..."
:
"Создать аккаунт"
}


</button>



</form>




<div className="text-center mt-6 text-slate-300">


Уже есть аккаунт?


<Link

href="/login"

className="text-blue-400 ml-2 hover:text-blue-300"

>

Войти

</Link>


</div>



</div>


</div>


</main>

);


}
